import { ClientDomain } from '../client-domain.types';

export const baseClientDomain: ClientDomain = {
  id: '1',
  clientId: 'client-123',
  domain: 'order.example.com',
  status: 'PENDING',
  currentStep: 'VERIFY_CNAME',
  createdDate: '2023-01-01T00:00:00Z',
  updatedDate: '2023-01-02T00:00:00Z',
  distributionId: 'dist-123',
  certificateArn: 'cert-123',
  stepFnExecutionArn: 'stepfn-123',
  dnsRecord: {
    type: 'CNAME',
    name: 'order.example.com',
    value: 'custom-domains.incentiviodev.com',
  },
};

export const activeClientDomain: ClientDomain = {
  ...baseClientDomain,
  id: 'active',
  status: 'ACTIVE',
  currentStep: null,
  domain: 'active.example.com',
  dnsRecord: {
    ...baseClientDomain.dnsRecord,
    name: 'active.example.com',
  },
};

export const errorClientDomain: ClientDomain = {
  ...baseClientDomain,
  id: 'error',
  status: 'FAILED',
  currentStep: 'PROVISION_TENANT',
  domain: 'error.example.com',
  failureReason: 'Failed to provision tenant due to timeout.',
  distributionId: null,
  certificateArn: null,
  dnsRecord: {
    ...baseClientDomain.dnsRecord,
    name: 'error.example.com',
  },
};

export const cancelClientDomain: ClientDomain = {
  ...baseClientDomain,
  id: 'cancel',
  status: 'PENDING',
  currentStep: 'VERIFY_CNAME',
  domain: 'cancel.example.com',
  distributionId: null,
  certificateArn: null,
  dnsRecord: {
    ...baseClientDomain.dnsRecord,
    name: 'cancel.example.com',
  },
};

export const newClientDomain: ClientDomain = {
  ...baseClientDomain,
  id: 'new',
  status: 'PENDING',
  currentStep: 'VERIFY_CNAME',
  domain: 'new.example.com',
  distributionId: null,
  certificateArn: null,
  dnsRecord: {
    ...baseClientDomain.dnsRecord,
    name: 'new.example.com',
  },
};

export const deletingClientDomain: ClientDomain = {
  ...baseClientDomain,
  id: 'deleting',
  status: 'DELETING',
  currentStep: null,
  domain: 'deleting.example.com',
  dnsRecord: {
    ...baseClientDomain.dnsRecord,
    name: 'deleting.example.com',
  },
};

/**
 * Basically let's make an in-memory db of client domains to really mock out
 * functionality in tests
 */
export let clientDomains: { [key: string]: ClientDomain } = {
  [activeClientDomain.id]: { ...activeClientDomain },
  [errorClientDomain.id]: { ...errorClientDomain },
  [cancelClientDomain.id]: { ...cancelClientDomain },
  [deletingClientDomain.id]: { ...deletingClientDomain },
};

export const restoreClientDomainsFixture = () => {
  clientDomains = {
    [activeClientDomain.id]: { ...activeClientDomain },
    [errorClientDomain.id]: { ...errorClientDomain },
    [cancelClientDomain.id]: { ...cancelClientDomain },
    [deletingClientDomain.id]: { ...deletingClientDomain },
  };
};
